/**Dependencies */
import React from 'react';

/**Components */
import { Container, Row, Col, Card } from 'react-bootstrap';

export const InformationSection = ({title, arrInfo}) => {    
    
  return (
    <div style={{ backgroundColor: "#efefef", padding: "50px 0" }}>
        
        <Container>            
            <div className="text-center mb-5">
            <h1 className='section-title text-secondary'>{title !== undefined ? title : "Conoce nuestros métodos de pago"}</h1>              
            </div>
            
            <Row className="text-center">
            {arrInfo.map((card, index) => (
                <Col key={index} md={arrInfo.length >= 4 ? 3 : 4} sm={6} xs={12} className="mb-4">
                <Card className="h-100 border-0" style={{ backgroundColor: "#efefef", boxShadow:'none' }}>
                    <Card.Body>
                        <div style={{height:'130px'}}>
                            <img className="my-5" src={card.icon} style={{width:'60px'}} alt={'icons ' + index}/>
                        </div>
                    <Card.Title className='text-secondary' style={{fontSize:'20px'}}>{card.title}</Card.Title>
                    <Card.Text className='py-2 text-center text-secondary' style={{textAlign:'start', fontSize:'15px', padding:'10px', fontStyle:'italic'}}>{card.description}</Card.Text>
                    </Card.Body>
                </Card>
                </Col>
            ))}
            </Row>
        </Container>
    </div>
  )
}
